// 주로 백엔드에 보낼 때 사용하는 Flag 변수
export const READY = 0
export const REGISTER = 1
export const TAKING = 2
export const END = 3
export const PAUSE = 4

// 주로 백엔드에서 온 값을 출력할 때 사용하는 Object
export const convertEventStateAsName = {
    "0": "접수 전",
    "1": "접수 진행",
    "2": "진행 중",
    "3": "종료",
    "4": "일시 정지",
}